"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@chakra-ui/react");
var layout_1 = require("../../common/layout");
var PageLoadingLayout_1 = require("../../common/layout/PageLoadingLayout");
var scrollToTopButton_1 = require("../../common/layout/components/scrollToTopButton");
var usePage_1 = require("../../common/hooks/usePage");
var ContentLayout_1 = require("../../common/layout/ContentLayout");
var PageLoading_1 = require("../../common/loading/PageLoading");
var PageNotFound_1 = require("../../common/error/PageNotFound");
var useShop_1 = require("../../common/hooks/useShop");
var useSetMeta_1 = require("../../common/hooks/useSetMeta");
var Main = function () {
    var _a = (0, usePage_1.usePage)(), pageData = _a.pageData, isPageLoading = _a.isPageLoading;
    var _b = (0, useShop_1.useShop)(), shopData = _b.shopData, isShopLoading = _b.isShopLoading, mainShopData = _b.mainShopData;
    if (isShopLoading)
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    if (!shopData)
        return (react_1.default.createElement(layout_1.Layout, { headerUrl: mainShopData === null || mainShopData === void 0 ? void 0 : mainShopData.logo_image },
            react_1.default.createElement(react_2.Box, { padding: "5rem" },
                react_1.default.createElement(PageNotFound_1.PageNotFound, null))));
    return (react_1.default.createElement(layout_1.Layout, { headerUrl: shopData.logo_image, isHeader: pageData === null || pageData === void 0 ? void 0 : pageData.is_header, isFooter: pageData === null || pageData === void 0 ? void 0 : pageData.is_footer, isInquire: pageData === null || pageData === void 0 ? void 0 : pageData.is_inquire, isLoading: isPageLoading, headerMenus: pageData === null || pageData === void 0 ? void 0 : pageData.header_menus },
        react_1.default.createElement(PageLoadingLayout_1.PageLoadingLayout, { isLoading: isPageLoading }, pageData ? (react_1.default.createElement(react_1.default.Fragment, null,
            (0, useSetMeta_1.useSetMeta)(pageData.title, pageData.description),
            react_1.default.createElement(ContentLayout_1.ContentLayout, { contentBlocksData: pageData.blocks }),
            react_1.default.createElement(scrollToTopButton_1.ScrollToTopButton, null))) : (react_1.default.createElement(react_2.Box, { padding: "5rem" },
            react_1.default.createElement(PageNotFound_1.PageNotFound, null))))));
};
exports.Main = Main;
